import { errorMsg } from '../constants/messages';

const becomePartnerInfoFormData = [
  {
    name: 'id',
    label: 'ID',
    fieldType: {
      name: 'text',
    },
    required: true,
    readonly: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Id', allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: false,
    default: '',
  },
  {
    title: 'Become a Partner Info Details',
    name: 'name',
    label: 'Name',
    fieldType: {
      name: 'text',
    },
    required: true,
    readonly: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Name', allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'email',
    label: 'E-mail',
    fieldType: {
      name: 'email',
    },
    required: true,
    readonly: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'E-mail' },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'countryCode',
    label: 'Country Code',
    fieldType: {
      name: 'text',
    },
    required: true,
    readonly: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Country Code' },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'mobileNumber',
    label: 'Mobile Number',
    fieldType: {
      name: 'text',
    },
    required: true,
    readonly: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Mobile Number' },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'country',
    label: 'Country',
    fieldType: {
      name: 'text',
    },
    required: true,
    readonly: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Country' },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'companyName',
    label: 'Company Name',
    fieldType: {
      name: 'text',
    },
    required: true,
    readonly: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Company Name' },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'website',
    label: 'Website',
    fieldType: {
      name: 'text',
    },
    required: false,
    readonly: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Website' },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'createdAt',
    label: 'Date Of Submission',
    fieldType: {
      name: 'text',
    },
    required: true,
    readonly: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Date Of Submission' },
    isTableHeader: true,
    isAccordian: true,
  },
  {
    name: 'message',
    label: 'Message',
    fieldType: {
      name: 'textarea',
    },
    required: true,
    readonly: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Message' },
    isTableHeader: false,
    isAccordian: true,
  },
  {
    name: 'lastStatus',
    label: 'Last Status',
    fieldType: {
      name: 'select',
      options: [
        { id: 'Duplicate', name: 'Duplicate', value: 'Duplicate' },
        { id: 'Contacted', name: 'Contacted', value: 'Contacted' },
        {
          id: 'Incorrect Information',
          name: 'Incorrect Information',
          value: 'Incorrect Information',
        },
        { id: 'Closed', name: 'Closed', value: 'Closed' },
      ],
    },
    required: false,
    readonly: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Last Status' },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
];

export { becomePartnerInfoFormData };
